module.exports = __webpack_public_path__ + "img/printing.5f2f2b1d.svg";